export enum StepActionType {
    SetStep,
}

export interface StepAction<T> {
    type: StepActionType;
    payload: T;
}

export function setStepAction(step: number): StepAction<any> {
    return {
        type: StepActionType.SetStep,
        payload: { step },
    };
}
